import {HttpResponse, HttpService} from "./http.service";
import {AccountTypeEnum} from "../models/account-type.enum";
import {AuthMeModel} from "../models/auth-me.model";
import {PublisherSubscriptionModel} from "../models/publisher/publisher-subscription.model";
import {AccountRegisterSubTypeEnum} from "../models/account-register-sub-type.enum";

export const AuthService = {

    async register(login: string, email: string, password: string, accountType: AccountTypeEnum, subscriptionType: AccountRegisterSubTypeEnum, publisherAlias = null) {
        let subscriptionPlan = 'freeAuthorBasic';
        if (accountType === AccountTypeEnum.PUB) {
            subscriptionPlan = subscriptionType === AccountRegisterSubTypeEnum.trialPublisher90d ? 'trialPublisher90d' : 'trialPublisher100x';
        }
        if (accountType === AccountTypeEnum.AGENCY) {
            accountType = AccountTypeEnum.PUB;
        }

        const data = {
            email,
            password,
            account_type: accountType,
            subscription_plan: subscriptionPlan,
            publisher_alias: publisherAlias,
            language: (window.navigator.language === 'pl-PL') ? 'pl' : 'en'
        };

        const response = await HttpService.post('auth/', data);

        return response.status;
    },
    async login(login: string, password: string) {
        const data = {
            username: login,
            password
        };

        const response: HttpResponse<LoginResponse> = await HttpService.post('auth/login/', data);

        if (response.status) {
            this.setToken(response.data.token);
            return response.data.token;
        } else {
            return false;
        }
    },
    async authMe(): Promise<AuthMeModel> {
        const response: HttpResponse<AuthMeModel> = await HttpService.get('auth/me/');

        return response.data;
    },
    async updateLang(lang: 'pl' | 'en'): Promise<any> {
        const response: HttpResponse<any> = await HttpService.put('auth/language/', {language: lang});

        return response.data;
    },
    getToken() {
        return localStorage.getItem('Token');
    },
    async logout() {
        await HttpService.post('auth/logout/', {});
        localStorage.removeItem('Token');
    },
    setToken(token: string) {
        localStorage.setItem('Token', token);
    },
    async getSubscription(): Promise<PublisherSubscriptionModel> {
        const response: HttpResponse<PublisherSubscriptionModel[]> = await HttpService.get('auth/subscriptions/');
        return response?.data[0];
    },
    async remindPassword(login: string): Promise<any> {
        const response: HttpResponse<any> = await HttpService.post('reset-password-send/', {login});

        return response.data;
    },
    async resetPassword(userId: string, timestamp: number, signature: string, password: string): Promise<any> {
        const body = {
            timestamp,
            signature,
            password,
            user_id: userId
        };

        const response:  HttpResponse<any> = await HttpService.post('reset-password/', body);

        return response.data;
    },
    async changePassword(oldPassword: string, newPassword: string, reNewPassword: string): Promise<any> {
        const data = {
            old_password: oldPassword,
            password: newPassword,
            password_confirm: reNewPassword
        };

        const response: HttpResponse<any> = await HttpService.post('auth/change-password/', data);

        return response.data;
    },
    async activeEmail(uid: string, token: string) {
        const data = {
            uidb64: uid,
            token: token
        };

        const response: HttpResponse<any> = await HttpService.post('auth/activate/', data);

        return response;
    }
}

export interface LoginResponse {
    token: string;
}
